import React, { useEffect, useState } from "react";
import { adminApi } from "../adminApi";

const tableCard = { background: "white", borderRadius: 12, border: "1px solid #E5E7EB", overflow: "hidden" };
const td = { padding: "10px 14px", fontSize: 12.5, color: "#0F1B2D", borderTop: "1px solid #F1F5F9" };
const th = { padding: "10px 14px", fontSize: 11, color: "#6B7280", textTransform: "uppercase", letterSpacing: 1, textAlign: "left", borderBottom: "1px solid #E5E7EB", fontWeight: 700 };
const input = { height: 32, padding: "0 8px", border: "1px solid #D1D5DB", borderRadius: 6, fontSize: 12.5 };
const btn = { background: "#1E3A5F", color: "white", border: "none", borderRadius: 6, padding: "7px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer" };

export default function ExpertAdminExperts() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", phone: "", role: "", specializations: "" });
  const [migrationRequired, setMigrationRequired] = useState(false);

  const load = async () => {
    const res = await adminApi.expertListExperts();
    if (res.ok) { setRows(res.data.experts || []); setMigrationRequired(!!res.data.migration_required); }
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name.trim()) return;
    const res = await adminApi.expertCreateExpert({
      ...form, specializations: form.specializations.split(",").map((s) => s.trim()).filter(Boolean),
    });
    if (res.ok) { setForm({ name: "", email: "", phone: "", role: "", specializations: "" }); load(); }
  };
  const toggleActive = async (e) => { await adminApi.expertPatchExpert(e.id, { is_active: !e.is_active }); load(); };
  const remove = async (id) => { if (window.confirm("Delete this expert record?")) { await adminApi.expertDeleteExpert(id); load(); } };

  if (migrationRequired) {
    return <div style={{ ...tableCard, padding: 16, color: "#B45309", fontSize: 13 }}>
      C-ORE Expert tables aren't migrated yet — run backend/migrations/2026-08_core_expert.sql in Supabase.
    </div>;
  }

  return (
    <div data-testid="expert-admin-experts">
      <div style={{ ...tableCard, padding: 14, marginBottom: 14, display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input data-testid="expert-form-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={input} />
        <input data-testid="expert-form-email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} style={input} />
        <input data-testid="expert-form-phone" placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} style={input} />
        <input data-testid="expert-form-role" placeholder="Internal role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} style={input} />
        <input data-testid="expert-form-specializations" placeholder="Specializations (comma-separated)" value={form.specializations} onChange={(e) => setForm({ ...form, specializations: e.target.value })} style={{ ...input, width: 220 }} />
        <button data-testid="expert-form-add-btn" onClick={add} style={btn}>Add Expert</button>
      </div>
      <div style={tableCard}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr><th style={th}>Name</th><th style={th}>Contact</th><th style={th}>Role</th><th style={th}>Specializations</th><th style={th}>Status</th><th style={th}></th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td style={td} colSpan={6}>No experts yet.</td></tr>}
            {rows.map((e) => (
              <tr key={e.id} data-testid={`expert-row-${e.id}`}>
                <td style={td}>{e.name}</td>
                <td style={td}>{e.email}<br />{e.phone}</td>
                <td style={td}>{e.role || "—"}</td>
                <td style={td}>{(e.specializations || []).join(", ") || "—"}</td>
                <td style={td}>{e.is_active ? <span style={{ color: "#047857" }}>Active</span> : <span style={{ color: "#6B7280" }}>Inactive</span>}</td>
                <td style={{ ...td, textAlign: "right" }}>
                  <button data-testid={`expert-toggle-${e.id}`} onClick={() => toggleActive(e)} style={{ ...btn, background: "white", color: "#1E3A5F", border: "1px solid #1E3A5F", marginRight: 6 }}>
                    {e.is_active ? "Deactivate" : "Activate"}
                  </button>
                  <button data-testid={`expert-delete-${e.id}`} onClick={() => remove(e.id)} style={{ ...btn, background: "white", color: "#DC2626", border: "1px solid #DC2626" }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
